import { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import userApiClient, { User } from '../../api/user';
import { useNavigate } from 'react-router-dom';

const useUserInitializer = (
  authUser: firebase.User | null,
  setUser: (user: User) => void,
  isAdmin: boolean,
  setHasAgreedToContract: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const [loading, setLoading] = useState(true);
  const [user, setLocalUser] = useState<User | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAndInitializeUser = async () => {
      try {
        if (!authUser) {
          setLoading(false);
          return;
        }

        await authUser.reload();
        const refreshedUser = firebase.auth().currentUser;

        if (
          (refreshedUser && refreshedUser.emailVerified) ||
          (isAdmin && refreshedUser)
        ) {
          let res = await userApiClient.getUser();

          if (!res) {
            if (!authUser.email) {
              console.error('Cannot create user: no email on auth account');
              return;
            }
            res = await userApiClient.upsertUser({ email: authUser.email });
          }

          setUser(res);
          setLocalUser(res);
          const hasAgreed = !!res?.studioContract?.accepted;
          setHasAgreedToContract(hasAgreed);

          if (!hasAgreed) {
            navigate('/contract-agreement');
          } else if ((!res.name || res.name.trim() === '') && !isAdmin) {
            navigate('/artist-page');
          }
        } else {
          console.warn('Email not verified. Waiting for verification...');
        }
      } catch (error) {
        console.error('Error in UserInitializer:', error);
      } finally {
        setLoading(false);
      }
    };

    checkAndInitializeUser();
  }, [authUser, setUser]);

  return { loading, user };
};

export default useUserInitializer;
